import React from 'react';
import background from "../img/promo-main-bg.svg"; 
import foreground from "../img/promo-bg-3.svg";
import AwardsSection from './AwardsSection';
import Jury from './Jury';
import PhotoGallery from './PhotoGallery';


const Home = () => {
  return (
    <>

    <div className="banner">
      <img src={background} alt="Background" className="banner-bg" />
      <img src={foreground} alt="Foreground" className="banner-fg" />

      <div className="banner-content">
        <h2 className="subtitle">Международный чемпионат</h2>
        <h1 className="title">"Global Construction Cup" </h1>
        <p className="description">
        Добро пожаловать на официальный сайт Международного чемпионата "Global Construction Cup" — престижного события, которое объединяет лучших профессионалов строительной отрасли со всего мира! Этот уникальный турнир, впервые состоявшийся в 2020 году, стал не просто соревнованием, а глобальной площадкой для демонстрации лидерства, инноваций и сотрудничества в строительной индустрии. Победа в чемпионате открывает международные карьерные возможности, подтверждая высокий уровень профессионализма и достижения участников.
        </p>
      </div>
    </div>

    <div className="about-section">
      <div className="about-content">
        <h2 className="about-title">Международное признание <br /> и значение победы</h2>
        <p className="about-text">
        Победители "Global Construction Cup" получают не только престижные награды, но и международное признание, становясь лидерами в строительной отрасли. Их проекты, идеи и достижения активно продвигаются на мировом уровне, открывая двери к сотрудничеству с крупнейшими строительными компаниями и организациями. Для руководителей и топ-менеджеров строительных компаний из стран СНГ победа в этом чемпионате становится важным этапом в их профессиональной карьере, подтверждая их лидерские качества и способность внедрять инновационные подходы в строительстве.
        </p>
      </div>

      <div className="about-content">
        <h2 className="about-title">Организатор чемпионата</h2>
        <p className="about-text">
        Организатором Международного чемпионата "Global Construction Cup" является Общероссийское межотраслевое объединение работодателей «Российский Союз строителей» (РСС). Благодаря усилиям РСС чемпионат приобрел статус ключевого события в строительной отрасли и стал важной платформой для обмена опытом и продвижения инноваций.
        </p>
      </div>


    </div>

    <div className="who-section">
      {/* <img src={globe} alt="Background" className="who-bg" />  */}
      <h2 className="who-title">Значимость для стран СНГ</h2>
        <p className="who-text">
        "Global Construction Cup" стал важным инструментом профессионального роста для строительных лидеров стран СНГ. Победа в чемпионате подтверждает не только личные достижения, но и способствует укреплению международного имиджа компаний, которые они представляют. Это соревнование стало платформой для формирования новых стандартов в строительной отрасли, демонстрируя передовые решения и достижения.
        </p>
      <div className="who-content">
      <div className='who-1'>
      <h3 className="who-subtitle">Цели чемпионата</h3>
      <ol className='who-ol-list'>
        <li>Популяризация профессии строителя. Продвижение престижности и значимости строительной профессии на международной арене.</li>
        <li>Продвижение инноваций. Демонстрация технологий и подходов, которые меняют современную строительную индустрию.</li>
        <li>Международное сотрудничество. Установление связей между профессионалами из различных стран и культур.</li>
        <li>Развитие лидерства. Поддержка руководителей строительных компаний, работающих над развитием отрасли.</li>
      </ol>
      <h2 className="who-subtitle">Наши достижения</h2>
      <p className='who-text'>За годы проведения чемпионат:</p>
      <ul className="who-list">
        <li>Привлек более 2000 участников из 30 стран;</li>
        <li>Стал стартовой площадкой для реализации более 200 инновационных проектов;</li>
        <li>Объединил профессионалов строительной отрасли, создав международное сообщество экспертов.</li>
      </ul>
      <p className='who-text'>Присоединяйтесь к "Global Construction Cup" и станьте частью мирового строительного сообщества, меняющего облик современной архитектуры и инфраструктуры. Ваша победа может стать новым этапом в карьере и вывести вашу компанию на международный уровень!</p>
      </div>

      <div className='who-2'>
      <h3 className="who-subtitle">Формат и условия участия</h3>
      <p className='who-text'>Чемпионат проводится в Москве и включает номинации:</p>
      <ul className="who-list">
          <li>Лидер года в строительной отрасли</li>
          <li>За внедрение инноваций в строительстве</li>
          <li>Лучший руководитель строительной компании</li>
          <li>Эффективное управление проектами</li>
          <li>За вклад в устойчивое строительство</li>
          <li>Лидер цифровой трансформации в строительстве</li>
          <li>За вклад в развитие отрасли</li>
          <li>Командный лидер года</li>
          <li>За стратегическое управление развитием компании</li>
          <li>За развитие корпоративной культуры и команды</li>
        </ul>
        <p className='who-text'>Оценку участников проводит независимая международная комиссия, состоящая из экспертов мирового уровня.</p>
        <p className='who-text'>К участию в чемпионате допускаются руководители и ТОП менеджеры строительных компаний с опытом работы на руководящих должностях не менее 3 лет.</p>
        <p className='who-text'>Победители чемпионата получают:</p>
        <ul className="who-list">
          <li>Международное признание;</li>
          <li>Уникальные карьерные перспективы;</li>
          <li>Возможность продвижения своих проектов на глобальном уровне.</li>
        </ul>
      </div>

      </div>
    </div>

    <div className='b-block'>
    <h2 className="who-title">История успеха</h2>
    <p className='b-text'>Идея создания чемпионата зародилась в 2019 году, когда стало очевидно, что строительная отрасль нуждается в платформе для международного обмена опытом и выявления лучших специалистов. Первый чемпионат, прошедший в 2020 году, стал историческим моментом, несмотря на глобальные вызовы. Он собрал топ-менеджеров и руководителей компаний, продемонстрировавших высокий уровень профессионализма и стремление к инновациям.</p>
    <div className="b-about-programm">
      <div className="about-programm__element">
        <div className="about-programm__content">
          <p>
          Сегодня чемпионат привлекает участников из более чем 30 стран, подтверждая свой статус как глобального мероприятия. Среди участников — руководители строительных компаний, архитекторы, инженеры и новаторы, представляющие ведущие компании отрасли.
          </p>
        </div>
      </div>
    </div>
    </div>

    <Jury/>

    <PhotoGallery/>
    <AwardsSection/>



    </>
  );
};

export default Home;
